import { useState } from "react";
import { useTranslation } from "react-i18next";
type Props = {
  partName: string;
  partSku: string;
  isSendingRequestQuote: boolean;
  onSend: (name: string, email: string, phoneNumber: string, message: string, shop: string) => void;
  onClose: () => void;
  shop: string;
};

export const RequestQuoteModal = ({ partName, partSku, isSendingRequestQuote, onClose, onSend, shop }: Props) => {
  const { t } = useTranslation();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [message, setMessage] = useState("");

  const onSendInternal = () => {
    if (
      !name ||
      name.trim().length === 0 ||
      !email ||
      email.trim().length === 0 ||
      !phoneNumber ||
      phoneNumber.trim().length === 0 ||
      !message ||
      message.trim().length === 0
    ) {
      alert("Please fill all the fields");
      return;
    }

    onSend(name, email, phoneNumber, message, shop);
  };

  return (
    <div
      className="p-2 fixed inset-0 w-full flex items-center justify-centerbg-black bg-opacity-50 bg-black dark:bg-black400 h-full justify-center items-center"
      onClick={onClose}
      style={{
        zIndex: 9991,
      }}
    >
      <div className="relative bg-white w-full h-10/12 rounded-2xl shadow-lg pb-5 lg:max-w-1/2 max-w-fit" onClick={(e) => e.stopPropagation()}>
        <div className="flex grow justify-end p-3">
          <button onClick={onClose} className="text-3xl">
            &times;
          </button>
        </div>
        <div className="flex grow justify-center items-center">
          <div className="w-full px-3 lg:px-5">
            <h1 className="text-2xl text-center font-bold">{t("request_quote_modal_title")}</h1>

            <p className="text-center mt-2 text-xs lg:text-md">{t("request_quote_modal_description")}</p>
            <p className="text-center mt-1 text-xs lg:text-md">{t("request_quote_modal_subtitle")}</p>

            <form className="mt-5">
              <div className="mb-4">
                <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="name">
                  {t("name")}
                </label>
                <input
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  id="name"
                  type="text"
                  placeholder={t("name")}
                />
              </div>
              <div className="mb-4">
                <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="email">
                  {t("email")}
                </label>
                <input
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  id="email"
                  type="email"
                  placeholder={t("email")}
                />
              </div>

              <div className="mb-4">
                <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="email">
                  {t("phone")}
                </label>
                <input
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  id="phoneNumber"
                  placeholder={t("phone")}
                />
              </div>

              <div className="mb-4">
                <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="message">
                  {t("message")}
                </label>
                <textarea
                  rows={3}
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  id="message"
                  placeholder={t("message")}
                ></textarea>
              </div>
              <div className="">
                <div className="ms-3 w-2/3">
                  <p className="text-xs lg:text-md">
                    {t("part_name")}: <strong>{partName}</strong>
                  </p>
                  <p className="text-xs lg:text-md">
                    {t("part_sku")}: <strong>{partSku}</strong>
                  </p>
                </div>
              </div>

              <div className="flex items-center justify-center mt-5">
                <button
                  disabled={isSendingRequestQuote}
                  className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                  type="button"
                  onClick={onSendInternal}
                >
                  {isSendingRequestQuote ? <span className="ml-2">Sending...</span> : "Send"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};
